
<template>
    <div class="changes" v-if="changes.length > 0">
        <legend>Коригування цін в заявках</legend>
        <BTable small striped bordered :items="changes" :fields="fields" responsive>
            <template #cell(app_id)="{ item }">
                <a :href="'/zaiavky-na-uchast/' + item.app_id " target="_blank">
                    {{item.app_id}}
                </a>
            </template>
            
            <template #cell(user_id_comerc)="{ item }">
             <span v-if="!item.reduction_id" >
                    {{ item.user_comerc?.name || '' }}
                </span>
                
                <a v-else :href="'/tender/show/' + item.reduction_id">Редукціон</a>
            </template>
            
        </BTable>
        
    </div>
</template>

<script>

import {
    BTable
} from 'bootstrap-vue-next';

export default {
    name: "protocol_changes",
    props : {
        protocol : {
            type : Object
        }
    },
    components : {
        BTable
    },
    
    data() {
        return {
            fields: [
                { key: 'app_id', label: 'Заявка', class: 'align-middle' },
                { key: 'author_app', label: 'Контрагент', class: 'align-middle' },
                { key: 'pozition', label: 'Позиція', class: 'align-middle' },
                { key: 'price', label: 'Ціна нова', class: 'align-middle' },
                { key: 'price_comerc', label: 'Ціна з заявки', class: 'align-middle text-right' },
                { key: 'user_id_comerc', label: 'Змінив', class: 'align-middle text-right' },
                { key: 'date_comerc', label: 'Дата', class: 'align-middle text-right' },
            ],
            show_binds: [],
        };
    },
    
    computed : {
        changes() {
            return this.protocol?.changes || [];
        }
    }
}
</script>


<style scoped>

</style>